import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = {
  class: "filter-container",
  style: {"position":"relative"}
}
const _hoisted_3 = { class: "action-list" }
const _hoisted_4 = { class: "dialog-footer" }
const _hoisted_5 = { class: "dialog-footer" }
const _hoisted_6 = { class: "dialog-footer" }

import Pagination from '@/components/Pagination.vue'
import Keys from '@/constant/key'
import { joinParams } from '@/utils'
import {useRouter} from 'vue-router'
import { useStore } from '@/store/index'
import SelectBrand from '@/components/SelectBrand.vue'
import { getCurrentInstance, reactive, ref, computed, nextTick, onActivated } from 'vue'
import { UserType } from '@/enums/user'
import { SettlementType, SettlementCycle, CooperateType } from '@/enums/brand'
import { oneClickListingApi, getBrandAccountListApi } from '@/apis/brand'
import { InvoiceType } from '@/enums/invoice'
import { BrandCat } from '@/enums/brand'
import { openRouteInNewWindow } from '@/utils/router-helper'


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const router = useRouter()
const store = useStore()
const userType = UserType[store.state.user.userInfo.user_type]
const role = store.state.user.userInfo.group_name
const user_id = store.state.user.userInfo.id

const forbiddenUserIds = ref(new Set(['6368', '7097', '7098']));
const canShowAttachment = computed(() => {
    return !forbiddenUserIds.value.has(user_id);
})

const filters = reactive({
    brand_id: '',
    brand_name: '', // 品牌名称
    status: '', // 品牌上下架状态
    money_type: '', // 结算方式
    page_size: 10,
    page: 1,
})

const tableData =  ref([])
const total = ref(0)
const getBrandList = async () => {
    const { code, data, msg } =  await proxy.$http.get(`/ptapi/shop/brand_list?${joinParams(filters)}`) as any
    if (code != 200) return proxy.$message({ type: 'error', message: msg })
    tableData.value = data.data
    total.value = data.total
}
getBrandList()

const rateDialogShow = ref(false) // 评分弹框
const currentBrandId = ref('') // 当前评分操作品牌ID
const currentBrandName = ref('') // 当前评分操作品牌名称
const rate = ref(0) // 评分
const onRateCancel = () => { // 取消评分
    currentBrandId.value = ''
    currentBrandName.value = ''
    rate.value = 0
    rateDialogShow.value = false
}
const onRateSave = async() => { // 保存评分
    if (!rate) {
            return proxy.$message({
            type: 'error',
            message: '请先进行评分'
        })
    }
    const { code, data, msg } = await proxy.$http.post('/ptapi/shop/brand_grade', {
        brand_id: currentBrandId.value,
        grade: rate.value
    })

    if (code != 200) return proxy.$message({ type: 'error', message: msg })
    getBrandList()
    rateDialogShow.value = false
}

const toDetail = (id, mode) => {
    router.push(`/brand/${mode}?id=${id}`)
}

const cats = ref({
    brand_id: '',
    lasttime_type: '',
    rule_day: 1,
})
const catsRules = reactive ({
    lasttime_type: [
        { required: true, message: '请选择下类型', trigger: 'blur' }
    ],
    rule_day: [
        { required: true, message: '请选择填写名称', trigger: 'blur' }
    ]
})
const dialogVisible = ref(false)  // 最晚付款时间弹框
const openDialog = (row) => {
    if(row.id){
        cats.value.brand_id = row.id
        cats.value.lasttime_type = row.lasttime_type
        cats.value.rule_day = row.rule_day
    }
    
    dialogVisible.value = true
}
const dialogBeforeClose = () => {
    cats.value.brand_id = ''
    cats.value.lasttime_type = ''
    cats.value.rule_day = 1
    dialogVisible.value = false
    getBrandList()
    nextTick(() => {
        proxy.$refs['addCat'].clearValidate()
    })
}
//编辑预付款
const updateRow = async () => {
    if(!cats.value.lasttime_type){
        return proxy.$message({ type: 'error', message: '请选择类型' })
    }
    if(cats.value.lasttime_type=='1' && !cats.value.rule_day || cats.value.lasttime_type=='2' && !cats.value.rule_day){
        return proxy.$message({ type: 'error', message: '请填写天数' })
    }
    
    const { code, data, msg } = proxy.$http.post('/admin/brands/set_brand_pay_lasttime', cats.value) as any
    if (code != 200)  return proxy.$message({ type: 'error', message: msg }) 
    proxy.$message({ type: 'success', message: '保存成功' })
    getBrandList()
    dialogVisible.value = false
}

// 一键上架：1-商品，2-门店
const onList = async (brand_id, type) => {
    const confirm = await proxy.$confirm(`确定上架该品牌下所有${ type == 1 ? '商品' : '门店'}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
    })

    if (confirm) {
        const { code, data, msg } = await oneClickListingApi(brand_id, type) as any
        if (code != 200)  return proxy.$message({ type: 'error', message: msg }) 
        proxy.$message({ type: 'success', message: '保存成功' })
        getBrandList()
    }
}

// 查看品牌下的所有账号
const accountForm = ref({
    user_name: '',
    user_pwd: '',
    shop_description: '',
    cat_type: '',
    c_user: [],
})
const accountDialogShow = ref(false)
const showAccountList = async (brand_id) => {
    const { code, data, msg } = await getBrandAccountListApi(brand_id) as any
    if (code != 200)  return proxy.$message({ type: 'error', message: msg }) 
    
    accountForm.value = data
    accountDialogShow.value = true
}
const onAccountEdit = (id) => {
    openRouteInNewWindow({
        path: '/merchant-admin/shop-edit',
        query: {
            id: id,
            t: 'edit',
            v: 1
        }
    })
}

// 导出
const brandOutput = () => {
    window.open(`${Keys.baseUrl}/channel/brandRule?${joinParams({
        ...filters,
        user_id: store.state.user.userInfo.id,
        user_name: store.state.user.userInfo.username
    })}`)
}
    
const onBrandChange = (val) => {
    filters.brand_id = val
}
const search = () => {
    filters.page = 1
    getBrandList()
}
const onPageChange = (val) => {
    filters.page = val
    getBrandList()
}
const onSizeChange = (val) => {
    filters.page_size = val
    getBrandList()
}

onActivated(() => {
    getBrandList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_rate = _resolveComponent("el-rate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SelectBrand, {
        ifBody: 2,
        onBrandChange: onBrandChange,
        disabled: !!filters.brand_name
      }, null, 8, ["disabled"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.brand_name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.brand_name) = $event)),
        placeholder: "品牌名称",
        style: {"width":"200px"},
        disabled: !!filters.brand_id
      }, null, 8, ["modelValue", "disabled"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.status,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.status) = $event)),
        placeholder: "请选择状态",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "上架",
            value: 1
          }),
          _createVNode(_component_el_option, {
            label: "下架",
            value: 2
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.money_type,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.money_type) = $event)),
        placeholder: "请选择结算方式",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "后结算",
            value: _unref(SettlementType)['后结算']
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            label: "预付款",
            value: _unref(SettlementType)['预付款']
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (search()))
      }, {
        default: _withCtx(() => _cache[19] || (_cache[19] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      (_unref(userType) === '蛋叔员工')
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            class: "filter-btn",
            type: "primary",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (brandOutput()))
          }, {
            default: _withCtx(() => _cache[20] || (_cache[20] = [
              _createTextVNode("导出品牌查看开放渠道")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      stripe: "",
      border: "",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "id",
          label: "品牌ID"
        }),
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "品牌名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cat_id",
          label: "品牌分类"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(BrandCat)[row.cat_id]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "shop_discount",
          label: "品牌折扣"
        }),
        _createVNode(_component_el_table_column, {
          prop: "invoice_type",
          label: "开票类型"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(InvoiceType)[row.invoice_type]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "tax_Point",
          label: "税点"
        }),
        _createVNode(_component_el_table_column, { label: "合作方式" }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(CooperateType)[row.creation_status]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "结款方式" }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(SettlementType)[row.money_type]) + _toDisplayString((_unref(SettlementType)[row.money_type] == '后结算' ? ' - ' + _unref(SettlementCycle)[row.payments_status] : '')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "状态" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.status === 1 ? '上架' : '下架'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "putaway_time",
          label: "上架时间"
        }),
        _createVNode(_component_el_table_column, {
          prop: "soldout_time",
          label: "下架时间"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "270"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_3, [
              (_unref(userType) === '蛋叔员工')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (toDetail(row.id, 'show'))
                  }, {
                    default: _withCtx(() => _cache[21] || (_cache[21] = [
                      _createTextVNode("查看")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_unref(userType) === '蛋叔员工')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (toDetail(row.id, 'edit'))
                  }, {
                    default: _withCtx(() => _cache[22] || (_cache[22] = [
                      _createTextVNode("编辑")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: _withModifiers(($event: any) => (_unref(router).push(`/brand/open-cities?brand_id=${row.id}&brand_name=${row.name}`)), ["prevent"])
              }, {
                default: _withCtx(() => _cache[23] || (_cache[23] = [
                  _createTextVNode("开通城市")
                ])),
                _: 2
              }, 1032, ["onClick"]),
              (_unref(userType) === '蛋叔员工')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 2,
                    type: "primary",
                    size: "small",
                    class: "mt5",
                    onClick: _withModifiers(($event: any) => (_unref(router).push(`/marketing/operate_product-list?brand_id=${row.id}`)), ["prevent"])
                  }, {
                    default: _withCtx(() => _cache[24] || (_cache[24] = [
                      _createTextVNode(" 查看商品 ")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_unref(userType) === '蛋叔员工')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 3,
                    type: "primary",
                    size: "small",
                    class: "mt5",
                    onClick: _withModifiers(($event: any) => (_unref(router).push(`/merchant-admin/shop-list?brand_id=${row.id}`)), ["prevent"])
                  }, {
                    default: _withCtx(() => _cache[25] || (_cache[25] = [
                      _createTextVNode(" 查看门店 ")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_dropdown, { class: "mt5" }, {
                dropdown: _withCtx(() => [
                  ((_unref(role).indexOf('超级管理员') !== -1 || _unref(role).indexOf('运营-平台组') !== -1 || _unref(role).indexOf('saas运营') !== -1 || _unref(role).indexOf('运营部-管理员') !== -1 || _unref(role).indexOf('客服') !== -1 || _unref(userType) === '合作商户'))
                    ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                        key: 0,
                        onClick: _withModifiers(($event: any) => (_unref(router).push(`/brand/distribution-rule?id=${row.id}&item_type=brand&brand_name=${row.name}`)), ["prevent"])
                      }, {
                        default: _withCtx(() => _cache[27] || (_cache[27] = [
                          _createTextVNode(" 品牌配规 ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_dropdown_item, {
                    onClick: _withModifiers(($event: any) => (_unref(router).push(`/brand/distribution-rule?id=${row.id}&item_type=city&brand_name=${row.name}`)), ["prevent"])
                  }, {
                    default: _withCtx(() => _cache[28] || (_cache[28] = [
                      _createTextVNode(" 城市配规 ")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]),
                  (_unref(userType) === '蛋叔员工')
                    ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                        key: 1,
                        onClick: ($event: any) => (openDialog(row))
                      }, {
                        default: _withCtx(() => _cache[29] || (_cache[29] = [
                          _createTextVNode(" 最晚付款时间 ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (canShowAttachment.value)
                    ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                        key: 2,
                        onClick: ($event: any) => (_unref(router).push(`/brand/attachment-list?id=${row.id}&name=${row.name}`))
                      }, {
                        default: _withCtx(() => _cache[30] || (_cache[30] = [
                          _createTextVNode(" 收费附件 ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_dropdown_item, {
                    onClick: _withModifiers(($event: any) => (_unref(router).push(`/brand/supplier-second-brand-list?brand_id=${row.id}&brand_name=${row.name}`)), ["prevent"])
                  }, {
                    default: _withCtx(() => _cache[31] || (_cache[31] = [
                      _createTextVNode(" 查看二级品牌 ")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]),
                  (_unref(role).indexOf('品牌结算方式修改') !== -1 || _unref(role).indexOf('超级管理员') !== -1 || _unref(role).indexOf('运营部-管理员') !== -1)
                    ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                        key: 3,
                        onClick: _withModifiers(($event: any) => (_unref(router).push(`/brand/expand-brand-edit?brand_id=${row.id}&brand_name=${row.name}`)), ["prevent"])
                      }, {
                        default: _withCtx(() => _cache[32] || (_cache[32] = [
                          _createTextVNode(" 合作方式 ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_unref(userType) === '蛋叔员工')
                    ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                        key: 4,
                        onClick: ($event: any) => (onList(row.id, 1))
                      }, {
                        default: _withCtx(() => _cache[33] || (_cache[33] = [
                          _createTextVNode(" 一键上架商品 ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_unref(userType) === '蛋叔员工')
                    ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                        key: 5,
                        onClick: ($event: any) => (onList(row.id, 2))
                      }, {
                        default: _withCtx(() => _cache[34] || (_cache[34] = [
                          _createTextVNode(" 一键上架门店 ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_unref(userType) === '蛋叔员工')
                    ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                        key: 6,
                        onClick: ($event: any) => (showAccountList(row.id))
                      }, {
                        default: _withCtx(() => _cache[35] || (_cache[35] = [
                          _createTextVNode(" 商户号 ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "small"
                  }, {
                    default: _withCtx(() => _cache[26] || (_cache[26] = [
                      _createTextVNode(" 更多 "),
                      _createElementVNode("i", { class: "el-icon-arrow-down" }, null, -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"]),
    _createVNode(_component_el_dialog, {
      title: "最晚付款时间",
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dialogVisible).value = $event)),
      "before-close": dialogBeforeClose
    }, {
      footer: _withCtx((scope) => [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_el_button, { onClick: dialogBeforeClose }, {
            default: _withCtx(() => _cache[36] || (_cache[36] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (updateRow()))
          }, {
            default: _withCtx(() => _cache[37] || (_cache[37] = [
              _createTextVNode("保存")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: cats.value,
          "label-width": "90",
          ref: "addCat",
          rules: catsRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "类型：",
              prop: "lasttime_type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  style: {"width":"300px"},
                  filterable: "",
                  modelValue: cats.value.lasttime_type,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((cats.value.lasttime_type) = $event)),
                  placeholder: "请选择类型：",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: 1,
                      label: "自然日"
                    }),
                    _createVNode(_component_el_option, {
                      value: 2,
                      label: "工作日"
                    }),
                    _createVNode(_component_el_option, {
                      value: 3,
                      label: "月底"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (cats.value.lasttime_type == '1' ||cats.value.lasttime_type == '2')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "天数：",
                  prop: "rule_day"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: cats.value.rule_day,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((cats.value.rule_day) = $event)),
                      modelModifiers: { trim: true },
                      placeholder: "请输入天数：",
                      onInput: _cache[7] || (_cache[7] = ($event: any) => (cats.value.rule_day = Number(cats.value.rule_day.toString().replace(/[^0-9]/g,'')))),
                      style: {"width":"170px"},
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: rateDialogShow.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((rateDialogShow).value = $event)),
      title: "评分"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_el_button, { onClick: onRateCancel }, {
            default: _withCtx(() => _cache[38] || (_cache[38] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: onRateSave
          }, {
            default: _withCtx(() => _cache[39] || (_cache[39] = [
              _createTextVNode("保存")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "80px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "品牌" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: currentBrandName.value,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((currentBrandName).value = $event)),
                  readonly: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "评分" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_rate, {
                  modelValue: rate.value,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((rate).value = $event)),
                  "allow-half": "",
                  size: "large",
                  "show-score": "",
                  "text-color": "#ff9900"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: accountDialogShow.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((accountDialogShow).value = $event)),
      title: "账号列表"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_6, [
          _createVNode(_component_el_button, {
            onClick: _cache[17] || (_cache[17] = ($event: any) => (accountDialogShow.value = false))
          }, {
            default: _withCtx(() => _cache[41] || (_cache[41] = [
              _createTextVNode("取消")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-width": "120px",
          disabled: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "品牌" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: accountForm.value.user_name,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((accountForm.value.user_name) = $event)),
                  readonly: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "密码" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: accountForm.value.user_pwd,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((accountForm.value.user_pwd) = $event)),
                  readonly: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "商户简称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: accountForm.value.shop_description,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((accountForm.value.shop_description) = $event)),
                  readonly: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "账号类型" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: accountForm.value.cat_type,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((accountForm.value.cat_type) = $event)),
                  placeholder: "请选择账号类型",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: 1,
                      label: "实物"
                    }),
                    _createVNode(_component_el_option, {
                      value: 2,
                      label: "电子券"
                    }),
                    _createVNode(_component_el_option, {
                      value: 3,
                      label: "实物+电子券"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (accountForm.value.c_user.length > 0)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 0,
              data: accountForm.value.c_user
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "id",
                  label: "id",
                  width: "80"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "user_name",
                  label: "登录名"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "shop_description",
                  label: "简称"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "cat_type",
                  label: "类型",
                  width: "80"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.cat_type == 1 ? '实物' : row.cat_type == 2 ? '电子券' : '实物+电子券'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  width: "80"
                }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small",
                      link: "",
                      onClick: ($event: any) => (onAccountEdit(row.shop_id))
                    }, {
                      default: _withCtx(() => _cache[40] || (_cache[40] = [
                        _createTextVNode("编辑")
                      ])),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})